import updateQuantities from "../../utils/StructureUtils/StructureUtils";
import {
  DELETE_QUANTITY,
  GET_GROUPED_QUANTITIES_ERROR,
  GET_GROUPED_QUANTITIES_REQUEST,
  GET_GROUPED_QUANTITIES_SUCCESS,
  //GET_QUANTITIES,
  GET_QUANTITIES_ERROR,
  GET_QUANTITIES_REQUEST,
  GET_QUANTITIES_SUCCESS,
  GET_QUANTITY,
  UPDATE_QUANTITY_ERROR,
  UPDATE_QUANTITY_REQUEST,
  UPDATE_QUANTITY_SUCCESS,
  SET_QUANTITIES_VALIDATED,
  UPDATE_PENALTY_FIELD,
} from "../types";

const initialState = {
  quantities: [],
  penalties: [],
  quantity: {},
  isFetchingGroupedQuantities: false,
  groupedQuantities: [],
  isFetching: false,
};
// eslint-disable-next-line
export default function (state = initialState, actions) {
  switch (actions.type) {
    case GET_QUANTITY:
      return {
        ...state,
        quantity: actions.payload,
      };
    case GET_QUANTITIES_REQUEST:
      return {
        ...state,
        isFetching: true,
        quantities: [],
        error: "",
      };
    case GET_QUANTITIES_SUCCESS:
      return {
        ...state,
        quantities: actions.payload.quantities || [],
        penalties: actions.payload.penalties,
        isFetching: false,
      };
    case GET_QUANTITIES_ERROR:
      return {
        ...state,
        isFetching: false,
        error: actions.payload,
      };
    case UPDATE_QUANTITY_REQUEST:
      return {
        ...state,
        error: "",
      };
    case UPDATE_QUANTITY_SUCCESS:
      const updatedQuantities = updateQuantities(state.quantities, actions);
      return {
        ...state,
        quantities: updatedQuantities,
      };
    case UPDATE_QUANTITY_ERROR:
      return {
        ...state,
        error: actions.payload,
      };
    case SET_QUANTITIES_VALIDATED: {
      const targetIds = new Set(actions.payload.ids);
      const { validated } = actions.payload;
      return {
        ...state,
        quantities: state.quantities.map((holder) => ({
          ...holder,
          quantities: (holder.quantities || []).map((qi) =>
            targetIds.has(qi.id) ? { ...qi, validated } : qi
          ),
        })),
      };
    }
    case UPDATE_PENALTY_FIELD: {
      const { id, field, value } = actions.payload;
      return {
        ...state,
        penalties: (state.penalties || []).map((p) =>
          p.id === id ? { ...p, [field]: value } : p
        ),
      };
    }
    case DELETE_QUANTITY:
      return {
        ...state,
        quantities: state.quantities.filter(
          (quantity) => quantity.id !== actions.payload
        ),
      };
    case GET_GROUPED_QUANTITIES_REQUEST:
      const newState = { ...state, isFetchingGroupedQuantities: true };
      if (state.groupedQuantities.length) newState.groupedQuantities = [];
      return newState;
    case GET_GROUPED_QUANTITIES_SUCCESS:
      return {
        ...state,
        isFetchingGroupedQuantities: false,
        groupedQuantities: actions.payload,
      };
    case GET_GROUPED_QUANTITIES_ERROR:
      return {
        ...state,
        isFetchingGroupedQuantities: false,
        error: actions.payload,
      };
    default:
      return state;
  }
}
